import React from 'react';
import Lottie from 'react-lottie';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import phonicsBackground from '@/assets/productCenter/phonics/phonics-bg.png';
import starData from '@/assets/lottie/star-data.json';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      <div
        className={styles['screen1-bg']}
        style={{ backgroundImage: `url(${phonicsBackground})` }}
        aria-hidden
      />
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-title']}`}
            style={{ animationDelay: '0.2s', animationDuration: '1.2s' }}
          >
            <div className={styles['screen1-title-row']}>
              爱学AI低龄段产品矩阵
              <span className={styles['screen1-star-wrap']} aria-hidden>
                <Lottie options={starLottieOptions} />
              </span>
            </div>
          </div>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-desc']}`}
            style={{ animationDelay: '0.4s', animationDuration: '1.2s' }}
          >
            专为低龄段孩子打造系统性成长方案，推出
            <span className={styles['highlight']}>爱学AI思维、爱学AI双语、爱学AI人文</span>
            三大产品。以“有趣点燃内驱、有料构建体系、有爱实现个性化”，让孩子在思维、语言与人文素养中真正学会思考、敢于表达、爱上阅读。
          </div>
        </div>
      </div>
    </section>
  );
}
